import {
    AckoCallConsent,
    CallConsentType,
    CallConsentMode,
} from '@acko-smart-calling-ui-sdk/ui';
import { store } from "@store/store";

const getDefaultSource = () => {
    if (typeof window === "undefined") return "auto";
    const currentNode = store?.getState()?.configuration?.config?.current_node;
    if (currentNode) return currentNode;
    const urlParams = new URLSearchParams(window.location.search);
    const nodeFromUrl = urlParams.get("current_node");
    if (nodeFromUrl) return nodeFromUrl;
    return window.location.pathname || "auto";
};

export const traiConcentCall = async (args: any) => {
    const phone = args?.payloadData?.phone;
    const source = args?.payloadData?.source;
    if (!phone) {
        console.warn("traiConcentCall: phone is required in params");
        return;
    }

    const body = {
        type: CallConsentType.PROMOTIONAL,
        mode: CallConsentMode.EXPLICIT,
        source: source ?? getDefaultSource(),
        // consent_timestamp: new Date().toISOString(),
        metadata: {
            lob: 'auto',
        },
        phone: phone,
    };
    const url = process.env.ENVIRONMENT?.toLowerCase() === "production" ? "https://www.acko.com" :"https://www.ackodev.com"
    const consent = new AckoCallConsent({
        baseUrl: url,
    });
    try {
        consent.createConsent(body).then((response) => {
            console.log("traiConcentCall Response:", response);
        }).catch((error) => {
            console.error("traiConcentCall Error:", error);
        });
    } catch (error) {
        console.error("traiConcentCall Error:", error);
    }
};
